// extracted by mini-css-extract-plugin
module.exports = {"popover":"DropdownMenu-popover-fbab","header":"DropdownMenu-header-fbab","scroll":"DropdownMenu-scroll-fbab","option":"DropdownMenu-option-fbab"};